import {ActionBuilder} from "co-redux-builders";
import {FormResultAllCriteriaProps} from "../../../ws/formResult/TaskFormResultListAll";

export default ActionBuilder.build({
    onSetCriteria: (criteria: FormResultAllCriteriaProps) => ({criteria}),

    clearFormResultAllListCardReducer: () => ({}),
});